import config from 'config';
import Styles from './Logo.styles';
import { ResponsiveFloraTypography } from 'ui/components';

export const Logo = () => {
  const isEud = config.app.short === 'eud';

  return (
    <Styles.LogoWrapper>
      <Styles.LogoImage>
        <Styles.Image
          src={isEud ? '/images/eud-gold-color.svg' : '/images/vdf_sem_marcas.svg'}
          alt={isEud ? 'Logo de Representante Eudora' : 'Logo dos Revendedores Grupo Boticário'}
          data-brand={config.app.short}
        />
      </Styles.LogoImage>

      {isEud && (
        <ResponsiveFloraTypography fontSize="subtitle" fontWeight="regular">
          Área exclusiva para {config.communication.userNamingConvention.plural}.
        </ResponsiveFloraTypography>
      )}
    </Styles.LogoWrapper>
  );
};
